import React, { useState } from 'react';

import Chart1 from './chart1/chart1';
import Chart2 from './chart2/chart2';

// styles
import './chart1Wrapper.scss';
import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';
import DataMethodLink from '../dataMethodLink/dataMethodLink';

const Chart1Wrapper = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const handleChangeTab = (index: number) => {
    setSelectedTab(index);
  };

  return (
    <div className="chart1wrapper">
      <ChartTitleIntro number={1} title="Wie hat sich die Einkommensverteilung in der Schweiz von 1917 bis heute entwickelt?">
        Die folgenden interaktiven Grafiken zeigen den Anteil der obersten Einkommensgruppen am Gesamteinkommen aller Steuerzahler im jeweiligen Ort.
        Die Anteile geben an, wie viel Prozent von allen Einkommen die obersten Einkommensgruppen auf sich vereinen. Wenn zum Beispiel der
        Einkommensanteil der Top-10%-Verdiener bei 35% liegt, haben sie im entsprechenden Jahr 35% des Gesamteinkommens eingenommen. Die Verteilung
        vor Steuern widerspiegelt die Einkommenssituation, bevor der Staat die Einkommen umverteilt. Die Verteilung nach Steuern zeigt die Situation
        nach Umverteilung durch den Staat. Hier erfahren Sie mehr zu <DataMethodLink />.
      </ChartTitleIntro>

      <div className="charttabs">
        <div className="charttabs-tabs">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => handleChangeTab(0)}>
            1.1 INTERKANTONALER VERGLEICH DER TOPEINKOMMENSANTEILE
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => handleChangeTab(1)}>
            1.2 ENTWICKLUNG DER TOPEINKOMMENSANTEILE
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">1.1 INTERKANTONALER VERGLEICH DER TOPEINKOMMENSANTEILE</div>
            <Chart1 />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">1.2 ENTWICKLUNG DER TOPEINKOMMENSANTEILE</div>
            <Chart2 />
          </div>
        </div>
      </div>
      <div className="d-md-none align-center">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default Chart1Wrapper;
